'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertIcon = function AlertIcon(props) {
  switch (props.level) {
    case 'danger':
      return _react2.default.createElement(
        'div',
        { className: 'pxl-alert__icon-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'pxl-alert__icon icon-reverse icon-circle' },
          _react2.default.createElement('i', { className: 'pxl-alert__icon icon-attention-alt', 'aria-hidden': 'true' })
        )
      );

    case 'success':
      return _react2.default.createElement(
        'div',
        { className: 'pxl-alert__icon-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'pxl-alert__icon icon-reverse icon-circle' },
          _react2.default.createElement('i', { className: 'icon-check', 'aria-hidden': 'true' })
        )
      );

    case 'warning':
      return _react2.default.createElement(
        'div',
        { className: 'pxl-alert__icon-wrapper' },
        _react2.default.createElement('i', { className: 'pxl-alert__icon icon-warning', 'aria-hidden': 'true' })
      );

    case 'info':
    default:
      return _react2.default.createElement(
        'div',
        { className: 'pxl-alert__icon-wrapper' },
        _react2.default.createElement('i', { className: 'pxl-alert__icon icon-lightbulb', 'aria-hidden': 'true' })
      );
  }
};

AlertIcon.propTypes = {
  level: _propTypes2.default.oneOf(['danger', 'info', 'success', 'warning'])
};

exports.default = AlertIcon;